
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, IMassUpdateCriteria } from "@tylertech/tyler-api-types";

/**
 * MassUpdateService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class MassUpdateService {
    constructor(private readonly $apiService: ApiService) { }
    
    MassUpdate(pCriteria: IMassUpdateCriteria): Promise<boolean> {
        return this.$apiService.sendAuth("IMassUpdateService/MassUpdate", pCriteria);
    }
    MassUpdateProperties(pProviderId: string): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IMassUpdateService/MassUpdateProperties", pProviderId);
    }
}
